import axios from 'axios'
import { ElLoading, ElMessage } from 'element-plus'
import router from '@/router'
import globalConfig from '@/globalConfig'
// let loadingObj = null


//创建一个axios实例
export const service = axios.create(
    {
        timeout: 60000,
        baseURL: globalConfig.BASEURL,
    }
)

//请求拦截
service.interceptors.request.use(config => {
    let userinfo:string|null = localStorage.getItem('userInfo');
    let token = ''
    if(!userinfo){
        userinfo = ''
    }else{
        const user = JSON.parse(userinfo)
        token = user.token

    }
    
    const headers:any= {
        "Content-Type": 'application/json',
        "Authorization": token
    }
    config.headers = headers;

    return config;

})

//响应拦截
service.interceptors.response.use(
    response => {
        // loadingObj.close()
        // console.log(response)

        // console.log('全部返回数据：'+JSON.stringify(response))
        if (response.status === 200) {
            const res = response.data
            if (res.status === 401) {
                // ElMessage.error('登录超时')
                localStorage.clear()
                router.push({ path: '/login' }).then(() => { }).catch(err => { console.log(err) })

            } 
            else {
                return res
            }

        } else {
            ElMessage.error('服务器错误')
            return Promise.reject(new Error('服务器错误'))
        }

    },
    error => {
        // console.log(error)
        if(error.code==="ECONNABORTED"){
            ElMessage.error('请求超时')
            return
        }
        if(error.code==="ERR_NETWORK"){
            //服务端没有启动
            // ElMessage.error('无法访问服务器')

            return
        }
        
        ElMessage.error('服务器错误2')
        return Promise.reject(error)
    }
)

